var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_378_30310)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#202020"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7786 29.0326C16.5807 29.0326 16.3828 28.9596 16.2266 28.8034C15.9245 28.5013 15.9245 28.0013 16.2266 27.6992L23.0182 20.9076C23.5182 20.4076 23.5182 19.5951 23.0182 19.0951L16.2266 12.3034C15.9245 12.0013 15.9245 11.5013 16.2266 11.1992C16.5286 10.8971 17.0286 10.8971 17.3307 11.1992L24.1224 17.9909C24.6536 18.5221 24.9557 19.2409 24.9557 20.0013C24.9557 20.7617 24.6641 21.4805 24.1224 22.0117L17.3307 28.8034C17.1745 28.9492 16.9766 29.0326 16.7786 29.0326Z",
    fill: "#F9F9F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_378_30310",
    x: -20,
    y: -20,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_378_30310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_378_30310",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowIcon);
export default __webpack_public_path__ + "static/media/circle-arrow-icon.9a799d02bd43370cbb877326e24a3338.svg";
export { ForwardRef as ReactComponent };